import { useState } from 'react';

export const getCurrentForeningReportNumber = () => {
  const currentForeningReportNumber = sessionStorage.getItem('currentForeningReportNumber');
  return JSON.parse(currentForeningReportNumber)
}

export default function useCurentForeningReportNumber() {
  const [currentForeningReportNumber, setCurrentForeningReportNumber] = useState(getCurrentForeningReportNumber)
  const saveCurrentForeningReportNumber = currentForeningReportNumber => {
    (currentForeningReportNumber === null)
      ? sessionStorage.removeItem('currentForeningReportNumber')
      : sessionStorage.setItem('currentForeningReportNumber', JSON.stringify(currentForeningReportNumber))
    setCurrentForeningReportNumber(currentForeningReportNumber)

  }
  return {
    currentForeningReportNumber,
    setCurrentForeningReportNumber: saveCurrentForeningReportNumber
  }
}